<template>
  <div style="margin-top:30px">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="实际承运人姓名" style="margin-right:15px">
        <el-input v-model="entity.driverName" :disabled="true" />
      </el-form-item>
      <el-form-item label="实际承运人电话" style="margin-right:15px">
        <el-input v-model="entity.driverPhone" :disabled="true" />
      </el-form-item>
      <el-form-item label="货物种类" style="margin-right:15px">
        <el-input v-model="entity.coalTypeName" :disabled="true" />
      </el-form-item>
      <el-form-item label="装货数量" style="margin-right:15px">
        <el-input v-model="entity.loadQuantity" :disabled="true">
          <template slot="append">{{ entity.coalUnitName }}</template>
        </el-input>
      </el-form-item>
      <el-form-item label="装货吨位" style="margin-right:15px">
        <el-input v-model="entity.loadWeight" :disabled="true">
          <template slot="append"
            >吨</template
          >
        </el-input>
      </el-form-item>
      <el-form-item label="车牌号" style="margin-right:15px">
        <el-input v-model="entity.vehicleLicense" :disabled="true" />
      </el-form-item>
      <el-form-item label="装货时间" style="margin-right:15px">
        <el-input v-model="entity.fillTime" :disabled="true" />
      </el-form-item>
      <el-form-item label="装货单据" style="margin-right:15px">
        <template v-for="(item, index) in entity.loadImgUrlList">
          <el-image
            v-if="item"
            :key="'img_' + index"
            style="width: 146px; height: 146px;margin:2px;"
            :src="item"
            :preview-src-list="entity.loadImgUrlList"
          />
        </template>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="allowFunc">同 意</el-button>
      <el-button type="primary" @click="rejectFunc">拒 绝</el-button>
    </div>
  </div>
</template>
<script>
import {
  orderDetailInfoLoadAndUnloadConfirm,
  shipperConfirmLoading
} from "@/api/transport";

export default {
  data() {
    return {
      pageType: "loadAffirm",
      entity: {},
      form: {}
    };
  },
  created() {},
  methods: {
    init(entity) {
      this.form.code = entity.code;
      orderDetailInfoLoadAndUnloadConfirm(entity.code)
        .then(response => {
          this.entity = response.data;
          if (this.entity.loadImgUrlList) {
            this.entity.loadImgUrlList = this.entity.loadImgUrlList.filter(
              item => item != ""
            ); // 过滤空白
          }
        })
        .then(() => this.$refs["form"].resetFields());
    },
    rejectFunc() {
      this.form.isLoadingConfirm = 2;
      this.funcSubmit();
    },
    allowFunc() {
      this.form.isLoadingConfirm = 1;
      this.funcSubmit();
    },
    funcSubmit() {
      const rLoading = this.openLoading();
      const data = this.form;
      shipperConfirmLoading(data)
        .then(response => {
          this.$message({ message: response.msg, type: "success" });
          this.$emit("fatherSubmitMethod", this.pageType);
          rLoading.close();
        })
        .then(() => this.$refs["form"].resetFields());
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", this.pageType);
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  float: right;
}
</style>
